import RichTextEditor from "../../../components/TextEditor";
import { Stack, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import AppLoader from "../../../components/AppLoader";
import PaperContainer from "../../../components/Containers/PaperContainer";
import GlobalButton from "../../../components/CustomButton";
import {
  getAdminSetting,
  updateAdminSetting,
} from "../../../services/adminSettingApiFn";
import { handleOpenSnackBar } from "../../../utils";
import { t } from "i18next";

const AboutUsPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [textEn, setTextEn] = useState("");
  const [textRo, setTextRo] = useState("");
  const [setting, setSetting] = useState(null);

  const decodeHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.documentElement.textContent;
  };

  useEffect(() => {
    fetchAdminSetting();
  }, []);

  const fetchAdminSetting = async () => {
    try {
      setIsLoading(true);
      const response = await getAdminSetting();
      if (response.data.status === "success") {
        const data = response.data.data;
        setSetting(data);
        setTextEn(decodeHtml(data.aboutUs?.en || "<p>...</p>"));
        setTextRo(decodeHtml(data.aboutUs?.ro || "<p>...</p>"));
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const updateSetting = async () => {
    try {
      const payload = {
        aboutUs: {
          en: textEn,
          ro: textRo,
        },
      };
      setIsLoading(true);
      const response = await updateAdminSetting(setting?._id, payload);
      if (response.data.status === "success") {
        handleOpenSnackBar("success", response.data.message);
        fetchAdminSetting();
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditorChange = (lang, html) => {
    if (lang === "en") {
      setTextEn(html);
    } else {
      setTextRo(html);
    }
  };

  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <PaperContainer title={t("aboutUs")} subtitle={t("viewEditAboutUs")}>
        <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
          <Tab label={t("english")} />
          <Tab label={t("romanian")} />
        </Tabs>

        {tabIndex === 0 && (
          <RichTextEditor
            value={textEn}
            onChange={(html) => handleEditorChange("en", html)}
          />
        )}

        {tabIndex === 1 && (
          <RichTextEditor
            value={textRo}
            onChange={(html) => handleEditorChange("ro", html)}
          />
        )}

        <Stack alignItems={"flex-end"}>
          <GlobalButton
            btnText={"update"}
            handleClickBtn={updateSetting}
            styleProps={{ mt: 3, height: 40, width: 100 }}
          />
        </Stack>
      </PaperContainer>
    </>
  );
};

export default AboutUsPage;
